<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.conversationId}">
      <select :value="conversationId" name="conversationId" class="form-control" @change="handleChange">
        <option value="">
          Select Conversation:
        </option>
        <optgroup v-if="textConversations.length > 0" label="Text">
          <option v-for="conversation in textConversations" :value="conversation.id">
            {{ conversation.name }}
          </option>
        </optgroup>
      </select>
    </div>
    <div v-if="showDuration" :class="{'has-error':errors.conversationWindow}">
      {{ partnerLabel }} will have <input v-model="conversationWindow.hours" class="form-control input-numeric" type="number" @input="handleChange">
      hours and <input v-model="conversationWindow.minutes" class="form-control input-numeric" type="number" @input="handleChange"> minutes to complete the conversation.
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      conversationId: String,
      conversationWindow: {
        type: Object,
        default: function(){
          return {hours: 4, minutes: 0}
        }
      },
    },
    computed: {
      partnerLabel() {
        return this.config.supportPartnerLabel;
      },
      allConversations() {
        return this.config.studyConversations;
      },
      textConversations() {
        return this.allConversations
          .filter(source => source.class === 'TextConversationConnector')
      },
      selectedSource() {
        return this.allConversations.find(source => source.id == this.conversationId)
      },
      showDuration() {
        return this.selectedSource && this.selectedSource.class === 'TextConversationConnector';
      }
    },
    watch: {
      'conversationId': function() {
        let duration = this.config.conversationDurations[this.conversationId];
        if (duration) {
          this.conversationWindow.hours = duration.hours;
          this.conversationWindow.minutes = duration.minutes;
        } else {
          this.conversationWindow.hours = 4;
          this.conversationWindow.minutes = 0;
        }
      }

    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isNumber(this.conversationId)) {
          this.errors.conversationWindow = "Please select a conversation.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
